import { Talent } from "../../Classes";

const tier2 = [
  new Talent(
    "Silent Resolve",
    "spell_nature_manaregentotem",
    [
      "Reduces the threat generated by your spells by ",
      "% and increases your hit chance by ",
      "%.",
    ],
    3,
    [
      [7, 14, 20],
      [1, 2, 3],
    ],
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    {
      isNew: false,
      isChanged: true,
      isMoved: false,
    }
  ),
  new Talent(
    "Improved Power Word: Fortitude",
    "spell_holy_wordfortitude",
    [
      "Increases the effect of your Power Word: Fortitude and Prayer of Fortitude by ",
      "%.",
    ],
    2,
    [[15, 30]]
  ),
  new Talent(
    "Improved Power Word: Shield",
    "spell_holy_powerwordshield",
    ["Increases the damage absorbed by your Power Word: Shield by ", "%."],
    3,
    [[5, 10, 15]]
  ),
  new Talent(
    "Martyrdom",
    "spell_nature_tranquility",
    [
      "Gives you a ",
      "% chance to gain the focused casting effect for 6 sec after being the victim of a melee or ranged critical strike. The focused casting effect prevents you from losing casting time from taking damage and increases your resistance to Interrupt effects by 20%.",
    ],
    2,
    [[50, 100]]
  ),
];

export default tier2;
